(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('UnitsArchiveAdministrationController', UnitsArchiveAdministrationController);

    UnitsArchiveAdministrationController.$inject = [
        '$q',
        '$scope',
        '$rootScope',
        '$kWindow',
        '$translate',
        'kendoUtility',
        'unitService',
        'baseDataService',
        'commonUtility',
        'htmlElementService',
        'sanitizeService',
        'confirmDialogService',
        'dateUtility'
    ];

    function UnitsArchiveAdministrationController(
        $q,
        $scope,
        $rootScope,
        $kWindow,
        $translate,
        kendoUtility,
        unitService,
        baseDataService,
        commonUtility,
        htmlElementService,
        sanitizeService,
        confirmDialogService,
        dateUtility
    ) {
        var langId = localStorage['NG_TRANSLATE_LANG_KEY'];
        let expandedRowIds = [];

        $scope.restoreSelected = restoreSelected;
        $scope.unSelectAllProducts = unSelectAllProducts;

        var unitsArchiveDataSource = new kendo.data.DataSource({
            transport: {
                read: function (e) {
                    var activeFilter = {
                        field: "IsActive",
                        operator: "contains",
                        value: "0"
                    };
                    !e.data.filter
                        ? e.data.filter = { filters: [] }
                        : e.data.filter.filters;

                    e.data.filter.filters.push(activeFilter)

                    unitService.getUnitsByFilter(
                        e.data.page,
                        e.data.pageSize,
                        e.data.filter.filters,
                        e.data.sort
                    ).then(response => {
                        $scope.units = response.items;
                        e.success({
                            data: response.items,
                            total: response.totalCount
                        });
                    });
                }
            },
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 500,
            schema: {
                data: "data",
                total: "total",
                model: {
                    id: 'id',
                    fields: {
                        externalUnitId: { editable: false },
                        description: { editable: false },
                        supplierName: { editable: false },
                        measurementUnitTypeId: { editable: false },
                        resourceId: { editable: false }
                    }
                },
            }
        });


        const unitsArchiveGridOptions = langId => ({
            dataSource: unitsArchiveDataSource,
            height: '100%',
            persistSelection: true,
            change: function (e) {
                if (this.select() && this.select().length > 0) {
                    setRestoreSelectedButtonDisabled(false);
                    setUnSelectAllButtonDisabled(false);
                } else {
                    setRestoreSelectedButtonDisabled(true);
                    setUnSelectAllButtonDisabled(true);
                }
            },
            pageable: {
                pageSize: 500,
                refresh: true,
                pageSizes: [100, 250, 500],
                buttonCount: 5,
                messages: {
                    display: $translate.instant('G_PAGING_DISPLAY'),
                    empty: $translate.instant('G_PAGING_EMPTY'),
                    page: $translate.instant('G_PAGING_PAGE'),
                    of: $translate.instant('G_PAGING_OF'),
                    itemsPerPage: $translate.instant('G_PAGING_ITEMSPERPAGE'),
                    first: $translate.instant('G_PAGING_FIRST'),
                    previous: $translate.instant('G_PAGING_PREVIOUS'),
                    next: $translate.instant('G_PAGING_NEXT'),
                    last: $translate.instant('G_PAGING_LAST'),
                    refresh: $translate.instant('G_PAGING_REFRESH')
                }
            },
            columns: [
                {
                    field: 'id',
                    hidden: true
                },
                {
                    field: 'externalUnitId',
                    title: $translate.instant('ADMIN_UNITS_PRODUCT_NUMBER'),
                    template: function (dataItem) {
                        return dataItem.externalUnitId ? sanitizeService.sanitizingStringContent(dataItem.externalUnitId) : '';
                    },
                },
                {
                    field: 'description',
                    title: $translate.instant('ADMIN_UNITS_PRODUCT_NAME'),
                    template: function (dataItem) {
                        return dataItem.description ? sanitizeService.sanitizingStringContent(dataItem.description) : '';
                    },
                },
                {
                    field: 'supplierName',
                    title: $translate.instant('ADMIN_UNITS_SUPPLIER'),
                    template: function (dataItem) {
                        const hasSupplier = dataItem.supplier !== null;
                        dataItem.supplierName = hasSupplier ? dataItem.supplier.name : '';
                        const warningIcon = !hasSupplier ?
                            '<i class="fas fa-exclamation-triangle text-warning" title="' +
                            $translate.instant('ADMIN_UNITS_MISSING_SUPPLIER') + '"></i> ' : '';
                        return warningIcon + dataItem.supplierName;
                    },
                },
                {
                    field: 'measurementUnitTypeId',
                    title: $translate.instant('ADMIN_UNITS_MEASUREMENT_UNIT'),
                    template: function (dataItem) {
                        let item = $scope.measurementTypes.find(function (measurementType) {
                            return measurementType.measurementUnitTypeId === dataItem.measurementUnitTypeId;
                        });

                        if (item) {
                            dataItem.measurementUnitType = item;
                            dataItem.measurementUnitTypeName = item.measurementUnitDescription;
                        }
                        return dataItem.measurementUnitTypeName ? dataItem.measurementUnitTypeName : '';
                    },
                    groupHeaderTemplate: $translate.instant('ADMIN_UNITS_MEASUREMENT_UNIT', null, null, langId) + ": #=items[0] && items[0].measurementUnitTypeName ? items[0].measurementUnitTypeName : '' #"
                },
                {
                    field: 'resourceId',
                    title: $translate.instant('ADMIN_UNITS_RESOURCE'),
                    template: function (dataItem) {
                        if (dataItem.resourceId) {
                            let item = $scope.resources.find(function (resource) {
                                return resource.resourceId == dataItem.resourceId;
                            });

                            if (item) {
                                dataItem.resource = item;
                                dataItem.resourceName = item.resourceDescription;
                            }
                        }

                        return dataItem.resourceName ? dataItem.resourceName : '';
                    },
                    groupHeaderTemplate: $translate.instant('ADMIN_UNITS_RESOURCE') + ": #=items[0] && items[0].resourceName ? items[0].resourceName : '' #",
                },
                {
                    selectable: true,
                    width: "40px"
                },
                {
                    command: [
                        {
                            name: 'restoreUnit',
                            template: `<a class="k-grid-restoreUnit"><i class="fas fa-undo" title="${$translate.instant('ADMIN_UNITS_RESTORE_BUTTON_TEXT')}"></i></a>`,
                            click: e => toggleUnitArchive(e),
                        },
                    ],
                    width: 100,
                }
            ],
            editable: false,
            detailInit: detailInit,
            detailTemplate: kendo.template($('#unit-batch-archive-template').html()),
            detailCollapse: (e) => {
                const dataGrid = $('#units-archive-administration-grid').data('kendoGrid');
                const dataItems = dataGrid.dataSource.view();

                const dataItem = dataItems.find(x => x.uid === e.masterRow.data('uid'));

                if (dataItem) {
                    expandedRowIds = expandedRowIds.filter(x => x !== dataItem.id);
                }
            },
            dataBound: function () {
                const dataGrid = $('#units-archive-administration-grid').data('kendoGrid');
                const dataItems = dataGrid.dataSource.view();

                // reopen expanded rows on grid refresh
                $.each(expandedRowIds, function (_, v) {
                    $.each(dataItems, function (_, y) {
                        if (v === y.id) {
                            dataGrid.expandRow(dataGrid.tbody.find("tr[data-uid='" + y.uid + "']"));
                        }
                    });
                });

                //hide select all button in products archive grid
                var selectAllCheckBox = $('#units-archive-administration-grid th input[aria-label="Select all rows"]');
                selectAllCheckBox[0].disabled = true;
            },
            filterable: {
                name: "FilterMenu",
                extra: false,
                operators: {
                    string: {
                        contains: $translate.instant('G_SEARCH_OPTION_CONTAINS', null, null, langId),
                    }
                },
            },
            filterMenuInit: function (e) {
                if (e.field === "resourceName" || e.field === "supplierName") {
                    let filterMultiCheck = this.thead.find("[data-field=" + e.field + "]").data("kendoFilterMenu");
                    filterMultiCheck.container.empty();
                    filterMultiCheck.checkSource.sort({
                        field: e.field,
                        dir: "asc"
                    });
                    filterMultiCheck.checkSource.filter([]);
                    filterMultiCheck.checkSource.data(filterMultiCheck.checkSource.view().toJSON());
                    filterMultiCheck.createCheckBoxes();
                }
            },
            resizable: true,
            sortable: true,
            groupable: true,
        });

        function restoreSelected() {
            var grid = $("#units-archive-administration-grid").data("kendoGrid");
            var selectedRows = grid.select();
            let selectedProductIds = [];
            let selectedProducts = [];

            $(selectedRows).each(function () {
                var rowdata = grid.dataItems().find(r => r.uid == $(this).attr("data-uid"));
                selectedProducts.push(rowdata);
            });

            selectedProductIds = selectedProducts.map(r => r.id);

            if (selectedProductIds.length > 0) {
                confirmDialogService.open(
                    {
                        modalWidth: 400,
                        modalHeight: 150
                    },
                    $translate.instant("ADMIN_UNITS_RESTORE_WARNING_PL"),
                    $translate.instant("ADMIN_UNITS_RESTORE_WARNING_TITLE"),
                    $translate.instant("G_OK"),
                    $translate.instant("G_CANCEL")
                ).then(dialogResult => {
                    if (dialogResult === true) {
                        unitService.updateUnitActiveStatus(selectedProductIds, true).then(result => {
                            openInformationDialog(`${selectedProductIds.length} ${$translate.instant("ADMIN_UNITS_RESTORED_MESSAGE_PL")}`);
                            refreshProductsArchiveGrid();
                            $rootScope.$broadcast('refreshProductsGrid');
                        }); 
                    }
                });
            }
        }

        $scope.$on('refreshProductArchiveGrid', () => refreshProductsArchiveGrid());

        function refreshProductsArchiveGrid() {
            var grid = $("#units-archive-administration-grid").data("kendoGrid");
            grid.clearSelection();

            if ($scope.unitsArchiveGridOptions) {
                $scope.unitsArchiveGridOptions.dataSource.read();
            }  
        }

        $scope.unitsArchiveGridOptions = unitsArchiveGridOptions($translate.use());
        $scope.$on('langChanged', (event, code) => {
            $scope.unitsunitsArchiveGridOptions = unitsArchiveGridOptions(code);
            const grid = kendoUtility.createWidget('kendoGrid', $scope.unitsArchiveGridOptions);
            kendoUtility.changeLangOfWidget(code, [() => grid('#units-archive-administration-grid')]);
            langId = code;
        });
        $scope.toggleUnitArchive = toggleUnitArchive;

        function toggleUnitArchive(event) {
            var unit = getUnitFromGrid(event)

            confirmDialogService.open(
                {
                    modalWidth: 400,
                    modalHeight: 150
                },
                $translate.instant("ADMIN_UNITS_RESTORE_WARNING") + `${"\n"}${unit.externalUnitId} ${unit.description}`,
                $translate.instant("ADMIN_UNITS_RESTORE_WARNING_TITLE"),
                $translate.instant("G_OK"),
                $translate.instant("G_CANCEL")
            ).then(dialogResult => {
                if (dialogResult === true) {
                    unitService.updateUnitActiveStatus([ unit.id ], true).then(result => {
                        openInformationDialog($translate.instant("ADMIN_UNITS_RESTORED_MESSAGE"));
                        refreshProductsArchiveGrid();
                        $rootScope.$broadcast('refreshProductsGrid');
                    });
                }
            });
        }

        function getUnitFromGrid(event) {
            const sender = event.currentTarget;
            const row = angular.element(sender).closest('tr');
            return $('#units-archive-administration-grid')
                .data('kendoGrid')
                .dataItem(row)
                .toJSON();
        }

        initController();

        function initController() {

            $rootScope.$broadcast('showBusyIndicator', {
                id: 'unitsArchiveAdministrationGrid',
                destination: '#units-archive-administration-grid'
            });

            htmlElementService.checkIfElementExists("filter-group")
                .then(function (result) {
                    commonUtility.calculateAdminTabMenuWidth();
                });

            setRestoreSelectedButtonDisabled(true);
            setUnSelectAllButtonDisabled(true);

            $q.all({
                getMeasurementUnitTypesWebapi:  baseDataService.getMeasurementUnitTypesWebapi(),
                getResourcesWebApi:             baseDataService.getResourcesWebApi()
            })
            .then(data => {
                $scope.measurementTypes = data.getMeasurementUnitTypesWebapi;
                $scope.resources        = data.getResourcesWebApi;
                refreshProductsArchiveGrid();
            })
            .catch(error => console.error(error))
            .finally(() => {
                $rootScope.$broadcast('hideBusyIndicator', 'unitsArchiveAdministrationGrid');
            });
        }

        function openInformationDialog(dialogContent) {
            var windowInstance = $kWindow.open({
                options: {
                    modal: true,
                    movable: false,
                    resizable: false,
                    visible: false,
                    width: 400
                },
                templateUrl: 'app/shared/popups/information-modal.html',
                windowTemplateUrl: 'app/shared/modal-base.html',
                controller: 'InformationModalController',
                resolve: {
                    content: () => { return dialogContent }
                }
            });
            windowInstance.result.then(function (response) {
                return response;
            });
        }

        function isBatchValid(batch, lineType) {
            var fieldName = "lifetimeInYearsMooring"
            switch (lineType) {
                case "mooring": {
                    fieldName = "lifetimeInYearsMooring";
                    break;
                }
                case "bridle": {
                    fieldName = "lifetimeInYearsBridles";
                    break;
                }
            }
            return {
                hasCertificate: !!batch.mediaId,
                hasLifetime: !!batch[fieldName],
                hasValidLifetime: batch[fieldName] > 0,
                hasCertificateDate: !!batch.certificateIssuedDate,
                isComplete: !!batch.mediaId &&
                    !!batch[fieldName] &&
                    batch[fieldName] > 0 &&
                    !!batch.certificateIssuedDate
            };
        }

        var unitBatchGridOptions = data => ({
            dataSource: {
                data,
                schema: {
                    model: {
                        id: 'id',
                    },
                }
            },
            noRecords: true,
            messages: {
                noRecords: $translate.instant('G_NORESULTS')
            },
            persistSelection: true,
            change: function (e) {
                var id = this.element[0].id.split("_")[0];
                if (id && this.select() && this.select().length > 0) {
                    document.getElementById(`${id}_move`).style.visibility = 'visible';
                } else {
                    document.getElementById(`${id}_move`).style.visibility = 'hidden';
                }
            },
            columns: [{
                hidden: true,
                field: 'id'
            },
            {
                field: 'batch',
                title: $translate.instant('ADMIN_UNITS_BATCH_NUMBER'),
                width: "350px"
            },
            {
                field: 'certificateIssuedDate',
                title: $translate.instant('UNIT_BATCH_CERTIFICATE_ISSUED_DATE'),
                width: "150px",
                template: function (dataItem) {
                    const warningIcon = !dataItem.certificateIssuedDate ?
                        '<i class="fas fa-exclamation-triangle text-warning" title="' +
                        $translate.instant('ADMIN_UNITS_MISSING_CERTIFICATE_DATE') + '"></i> ' : '';
                    return warningIcon + (dataItem.certificateIssuedDate ? dateUtility.formatDate(dataItem.certificateIssuedDate) : '');
                },
            },
            {
                field: 'isActive',
                title: $translate.instant('ADMIN_UNITS_ACTIVE'),
                width: "40px",
                template: function (dataItem) {
                    const checked = dataItem.isActive ? 'checked' : '';
                    return `<div class="center-content"><input type="checkbox" class="is-active-checkbox" ${checked} disabled/></div>`;
                },
            },
            {
                field: 'lifetimeInYearsMooring',
                title: $translate.instant('ADMIN_UNITS_LIFETIME_IN_YEARS_MOORING'),
                width: "150px",
                template: function (dataItem) {
                    const validity = isBatchValid(dataItem, "mooring");
                    const warningIcon = (!validity.hasLifetime || !validity.hasValidLifetime) ?
                        '<i class="fas fa-exclamation-triangle text-warning" title="' +
                        $translate.instant('ADMIN_UNITS_INVALID_LIFETIME') + '"></i> ' : '';
                    return warningIcon + (dataItem.lifetimeInYearsMooring || '');
                },
            },
            {
                field: 'lifetimeInYearsBridles',
                title: $translate.instant('ADMIN_UNITS_LIFETIME_IN_YEARS_BRIDLE'),
                width: "150px",
                template: function (dataItem) {
                    const validity = isBatchValid(dataItem, "bridle");
                    const warningIcon = (!validity.hasLifetime || !validity.hasValidLifetime) ?
                        '<i class="fas fa-exclamation-triangle text-warning" title="' +
                        $translate.instant('ADMIN_UNITS_INVALID_LIFETIME') + '"></i> ' : '';
                    return warningIcon + (dataItem.lifetimeInYearsBridles || '');
                },
            },

            {
                field: 'locationLogSummaries',
                title: $translate.instant('ADMIN_UNITS_LOCATIONS'),
                width: "150px",
                template: function (dataItem) {
                    if (!dataItem.locationLogSummaries) return '0';

                    const uniqueLocations = new Set(
                        dataItem.locationLogSummaries.map(log => log.locationName)
                    );

                    return `<a class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base location-details-btn">${uniqueLocations.size}</a>`;
                },
                attributes: {
                    "class": "text-center"
                }
            },
            ],
            dataBound: function (e) {
                var grid = e.sender;
                var rows = grid.tbody.find("tr");

                rows.each(function (index, row) {
                    var dataItem = grid.dataItem(row);
                    var validityMooring = isBatchValid(dataItem, "mooring");
                    var validityBridle = isBatchValid(dataItem, "bridle");

                    if (!validityMooring.isComplete || !validityBridle.isComplete) {
                        $(row).addClass('incomplete-row');
                    }
                });
            },
        });

        function detailInit(e) {
            if (!expandedRowIds.includes(e.data.id)) {
                expandedRowIds.push(e.data.id);
            }

            let requests = {};
            requests.getUnitBatches = unitService.getUnitBatchesWithLocationLogSummaries(e.data.id);
            $q.all(requests)
                .then(data => {
                    let batches = data.getUnitBatches.filter(x => x.isActive === false);
                    const element = e.detailRow.find(`#${e.data.id}_grid`);
                    $scope.unitBatchGridOptions = unitBatchGridOptions(batches);
                    element.kendoGrid($scope.unitBatchGridOptions);
                })
                .catch(error => console.error(error))
        }

        function setRestoreSelectedButtonDisabled(disabled){
            var restoreSelectedButton = $('button.k-button.k-grid-restore-selected-products');
            if (disabled) {
                restoreSelectedButton.prop('disabled', true);
                restoreSelectedButton.addClass('k-state-disabled');
                restoreSelectedButton.hide();
            } else {
                restoreSelectedButton.prop('disabled', false);
                restoreSelectedButton.removeClass('k-state-disabled');
                restoreSelectedButton.show();
            }
        }

        function unSelectAllProducts() {
            var grid = $("#units-archive-administration-grid").data("kendoGrid");
            grid.clearSelection();
        }

        function setUnSelectAllButtonDisabled(disabled) {
            var unSelectAllProductsButton = $('button.k-button.k-grid-unselect-all-archived-products');
            if (disabled) {
                unSelectAllProductsButton.prop('disabled', true);
                unSelectAllProductsButton.addClass('k-state-disabled');
                unSelectAllProductsButton.hide();
            } else {
                unSelectAllProductsButton.prop('disabled', false);
                unSelectAllProductsButton.removeClass('k-state-disabled');
                unSelectAllProductsButton.show();
            }
        }
    }
}) ();
